/* ReQaf PDP quantity-break tier picker.
 *
 * Each <reqaf-quantity-breaks> is a self-contained picker: reads its
 * embedded JSON config, wires click handlers to its tier buttons, and
 * on selection updates ANY of these targets that exist on the page:
 *   - input[data-reqaf-tier-qty]   → hidden qty input in each form
 *   - [data-reqaf-atc-total]        → ATC button total price (post-discount)
 *   - [data-reqaf-atc-compare]      → ATC button strikethrough compare price
 *                                     (hidden when qty === 1, shown when a
 *                                     tier discount is active)
 *   - [data-reqaf-atc-label]        → ATC button label (always "Add to cart")
 *   - [data-reqaf-tier-chip-title]  → mobile sticky-CTA tier title
 *   - [data-reqaf-tier-chip-sub]    → mobile sticky-CTA tier sublabel
 *
 * A single picker instance rendered in the desktop buybox drives every
 * form on the page (desktop + mobile), so we only render the picker
 * once even though there are two <product-form>s. */

class ReqafQuantityBreaks extends HTMLElement {
  connectedCallback() {
    if (this._booted) return;
    this._booted = true;

    const configEl = this.querySelector('script[data-reqaf-qb-config]');
    if (!configEl) return;
    try {
      this.config = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }

    this.buttons = Array.from(this.querySelectorAll('[data-tier-index]'));
    this.buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const idx = parseInt(btn.dataset.tierIndex, 10);
        if (!isNaN(idx)) this.selectIndex(idx);
      });
    });

    this.selectIndex(this.config.default_index || 0);
  }

  money(cents) {
    if (window.Shopify && window.Shopify.formatMoney && window.Shopify.money_format) {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  selectIndex(idx) {
    const tier = this.config.tiers[idx];
    if (!tier) return;

    this.buttons.forEach((btn, i) => {
      const selected = i === idx;
      btn.classList.toggle('is-selected', selected);
      btn.setAttribute('aria-checked', selected ? 'true' : 'false');
    });

    const unit = this.config.unit_cents;
    const total = unit * tier.qty - tier.off_cents;
    const compare = unit * tier.qty; // pre-discount anchor
    // Label stays "Add to cart" — box count is already visible on the
    // selected tier tile above, no need to duplicate on the button.
    const atcLabel = 'Add to cart';

    document.querySelectorAll('[data-reqaf-tier-qty]').forEach((el) => {
      el.value = tier.qty;
    });
    document.querySelectorAll('[data-reqaf-atc-total]').forEach((el) => {
      el.textContent = this.money(total);
    });
    document.querySelectorAll('[data-reqaf-atc-compare]').forEach((el) => {
      // Show strikethrough compare only when a tier discount is active
      // (qty ≥ 2 with off_cents > 0). At qty=1 nothing is being saved.
      if (tier.off_cents > 0 && tier.qty > 1) {
        el.textContent = this.money(compare);
        el.removeAttribute('hidden');
      } else {
        el.setAttribute('hidden', '');
      }
    });
    document.querySelectorAll('[data-reqaf-atc-label]').forEach((el) => {
      el.textContent = atcLabel;
    });
    document.querySelectorAll('[data-reqaf-tier-chip-title]').forEach((el) => {
      el.textContent = tier.title;
    });
    document.querySelectorAll('[data-reqaf-tier-chip-sub]').forEach((el) => {
      el.textContent = tier.sub;
    });
  }
}

if (!customElements.get('reqaf-quantity-breaks')) {
  customElements.define('reqaf-quantity-breaks', ReqafQuantityBreaks);
}
